var _style, _rect, _polyline, _polyline2, _path, _path2, _polygon, _polygon2, _polyline3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonizingSmokeDetector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 0.5,
    className: "st0",
    width: 13.1,
    height: 12.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3.6,11.5 8,7.1 12.5,11.5 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1.4,13 1.4,15.5 14.6,15.5 14.6,13 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,4c0.7,0,0.9,0.2,1,0.4c0,0.1,0,0.6,0.1,1C3.2,5.8,3.4,6,3.7,6.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.5,3.3c0.7,0,0.9,0.2,1,0.4s0,0.6,0.1,1.1C4.7,5.1,5,5.4,5.3,5.5"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "5.3,5.3 4.8,5.8 5.8,6.2 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3.9,5.8 3.4,6.3 4.4,6.7 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "5.2,11.5 8,8.7 10.9,11.5 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonizingSmokeDetector);
export default __webpack_public_path__ + "static/media/IonizingSmokeDetector.f5eee3b461d9c35a9c1660ea0717bc27.svg";
export { ForwardRef as ReactComponent };